import CoreUtils from '../../common/utils/CoreUtils';

import PreferenceManager from '../../application/PreferenceManager';

import ConfigurationApi from '../../api-services/ConfigurationApi';

import PropertyPageDataModel from '../../common/controls/PropertyPageDataModel';

import CounterpartiesSaveHelper from './CounterpartiesSaveHelper';
import CounterpartyList from './models/CounterpartyList';

export default class CounterpartiesDataModel extends PropertyPageDataModel {
  constructor(session, modificationStateUpdated) {
    super(session, modificationStateUpdated);

    this.counterpartyStateListener = this.onCounterpartyStateUpdated.bind(this);

    this.imageMimeTypes = '';
    this.counterparties = new CounterpartyList();
    this.counterparties.addStateListener(this.counterpartyStateListener);
    this.selectedCounterparty = null;

    this.loadCounterparties();
  }

  dispose() {
    this.selectedCounterparty = null;
    this.counterparties?.removeStateListener(this.counterpartyStateListener);
    this.counterparties?.dispose();
    this.counterparties = null;

    super.dispose();
  }

  onPropertyUpdated(propertyName, oldValue, newValue) {
    switch (propertyName) {
      case 'counterparties': {
        oldValue?.removeStateListener(this.counterpartyStateListener);
        oldValue?.dispose();

        newValue?.addStateListener(this.counterpartyStateListener);
        break;
      }
      default:
        break;
    }
  }

  onCounterpartyStateUpdated(state) {
    this.notifyModificationStateUpdated(this.translateState(state));
  }

  onCounterpartySelectionChanged(item) {
    this.updateProperties({
      selectedCounterparty: item,
    });

    if (CoreUtils.isDefinedAndNotNull(item))
      PreferenceManager.updateValue(
        PreferenceManager.Configuration,
        PreferenceManager.SelectedCounterparty,
        item.code
      );
  }

  submitChanges(operationCompleteHandler) {
    CounterpartiesSaveHelper.commitCounterpartyChanges(
      this.counterparties,
      operationCompleteHandler
    );
  }

  revertChanges() {
    this.counterparties.revertGroupItemValues();
  }

  async loadCounterparties() {
    var imageMimeTypes = await ConfigurationApi.getImageMimeTypes();

    var counterpartyDtos = await ConfigurationApi.getCounterparties();
    var metadataRulesDto = await ConfigurationApi.getMetadataRules();

    var counterparties = new CounterpartyList();
    counterparties.initDataObjects(counterpartyDtos, metadataRulesDto);

    var lastActiveCounterparty = PreferenceManager.retrieveValue(
      PreferenceManager.Configuration,
      PreferenceManager.SelectedCounterparty,
      null
    );

    var selectedCounterparty = null;
    if (CoreUtils.isDefinedAndNotNull(lastActiveCounterparty)) {
      selectedCounterparty = counterparties.find(
        counterparty => counterparty.code === lastActiveCounterparty
      );
    }

    if (CoreUtils.isUndefinedOrNull(selectedCounterparty) && counterparties.length > 0)
      selectedCounterparty = counterparties.getAt(0);

    this.updateProperties({
      imageMimeTypes: imageMimeTypes,
      selectedCounterparty: selectedCounterparty,
      counterparties: counterparties,
    });
  }

  translateState(state) {
    var translatedState = {};

    if (state.groupIsModified !== undefined)
      translatedState.isModified = state.groupIsModified;

    if (state.groupHasErrors !== undefined)
      translatedState.hasErrors = state.groupHasErrors;

    return translatedState;
  }
}